<script setup lang="ts">
interface Props {
	size?: string;
}
defineProps<Props>();
</script>
<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="size ?? '24'"
		:height="size ?? '24'"
		fill="none"
	>
		<g clip-path="url(#clip0_2040_151621)">
			<path
				d="M24.1857 6.18565C24.05 5.67507 23.7826 5.20907 23.4102 4.83431C23.0378 4.45955 22.5736 4.18916 22.0639 4.0502C20.1875 3.54565 12.6875 3.54565 12.6875 3.54565C12.6875 3.54565 5.1875 3.54565 3.31114 4.0502C2.80143 4.18916 2.33716 4.45955 1.96479 4.83431C1.59242 5.20907 1.32501 5.67507 1.18932 6.18565C0.6875 8.0702 0.6875 12.0002 0.6875 12.0002C0.6875 12.0002 0.6875 15.9302 1.18932 17.8147C1.32501 18.3253 1.59242 18.7913 1.96479 19.1661C2.33716 19.5409 2.80143 19.8112 3.31114 19.9502C5.1875 20.4547 12.6875 20.4547 12.6875 20.4547C12.6875 20.4547 20.1875 20.4547 22.0639 19.9502C22.5736 19.8112 23.0378 19.5409 23.4102 19.1661C23.7826 18.7913 24.05 18.3253 24.1857 17.8147C24.6875 15.9302 24.6875 12.0002 24.6875 12.0002C24.6875 12.0002 24.6875 8.0702 24.1857 6.18565Z"
				fill="#FF0302"
			/>
			<path
				d="M10.2344 15.5689V8.43164L16.5071 12.0003L10.2344 15.5689Z"
				fill="#FEFEFE"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2040_151621">
				<rect
					:width="size ?? '24'"
					:height="size ?? '24'"
					fill="white"
					transform="translate(0.664062 0.000244141)"
				/>
			</clipPath>
		</defs>
	</svg>
</template>
